import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {ModuleTypeTableComponent} from './table/module-type-table.component';
import {ModuleTypeEditComponent} from './edit/module-type-edit.component';
import {ModuleTypeCreateComponent} from './create/module-type-create.component';

@NgModule({
  declarations: [
    ModuleTypeTableComponent,
    ModuleTypeEditComponent,
    ModuleTypeCreateComponent
  ],
  imports: [SharedModule],
  exports: [
    ModuleTypeTableComponent,
    ModuleTypeEditComponent,
    ModuleTypeCreateComponent
  ]
})
export class ModuleTypeModule {}
